
import { TChartData } from "Interfaces";
import Loading from "Components/Loading/Loading";
import GlassCard from "Components/GlassCard/GlassCard";
import { Box, LinearProgress, Stack, Typography, styled } from "@mui/material";
import { formatNumber } from "Helpers/numbers";
import { formatPercentage } from "Helpers/percentage";
import { useMemo } from "react";

const StyledLinearProgress = styled(LinearProgress)({
  height: 12,
  borderRadius: 5,
  marginBottom: 4,
});

interface ISignalStatusCardProps {
  chartData: TChartData[];
  loading: boolean;
}

function SignalStatusCard({  chartData, loading }: ISignalStatusCardProps) {

  const pushedMetaResults = useMemo(() => {
    return chartData.reduce((acc, d) => acc + (Number(d.pushed) || 0), 0)
  }, [chartData]);

  const blockedMetaResults = useMemo(() => {
    return chartData.reduce((acc, d) => acc + (Number(d.blocked) || 0), 0)
  }, [chartData]);

  const percentageBlocked = useMemo(() => {
    const total = pushedMetaResults + blockedMetaResults;
    return total > 0 ? (blockedMetaResults / total) * 100 : 0;
  }, [blockedMetaResults, pushedMetaResults]);

  const percentagePushed = 100 - percentageBlocked;

  const { displayPushed, displayBlocked } = useMemo(() => {
    const vPushed = Math.log(1 + percentagePushed);
    const vBlocked = Math.log(1 + percentageBlocked);
    const sum = vPushed + vBlocked;
    if (sum === 0) return { displayPushed: 50, displayBlocked: 50 };
    return {
      displayPushed: (100 * vPushed) / sum,
      displayBlocked: (100 * vBlocked) / sum,
    };
  }, [percentagePushed, percentageBlocked]);

  if (loading) {
    return <Loading />
  }
  return <GlassCard sx={{height: "100%"}}>
    <Stack justifyContent="space-between" sx={{height: "100%"}}>
      <Box>
        <Typography variant="subtitle1">Signal Filtration</Typography>

        <Stack my={4} spacing={2}>
          <Stack>
            <Typography variant="subtitle2">Verified Human Signals</Typography>
            <StyledLinearProgress value={displayPushed} variant="determinate" color="success"/>
            <Typography variant="body1" color="secondary">{formatNumber(pushedMetaResults)} Quality Events Sent (Verified Humans)</Typography>
          </Stack>
          <Stack>
            <Typography variant="subtitle2" >Bot Signals Blocked</Typography>
            <StyledLinearProgress value={displayBlocked} variant="determinate" color="error"/>
            <Typography variant="body1" color="secondary">{formatNumber(blockedMetaResults)} Bot Signals Blocked</Typography>
          </Stack>
        </Stack>
      </Box>
      <Typography variant="h3" fontWeight="bold"><Typography variant="h1" component="span" fontWeight="bold">{formatPercentage(percentageBlocked)}</Typography> Junk Traffic Blocked</Typography>
    </Stack>
  </GlassCard>;
}
export default SignalStatusCard;